import { schema as d } from "./validator.js";
const p = (t) => async (s) => {
  const r = await d.validate(s), {
    event_type: n,
    isTestEvent: a,
    event_version: o,
    meta: i,
    attributes: c
  } = r;
  try {
    return (await t.post(
      "/record",
      {
        params: {
          event_type: n,
          event_version: o,
          isTestEvent: a,
          meta: i,
          attributes: c
        }
      }
    )).data;
  } catch (e) {
    if (e instanceof TypeError && (e.message.toLowerCase().includes("networkerror") || e.message.toLowerCase().includes("load failed") || e.message.toLowerCase().includes("failed to fetch")))
      return {};
    if (e instanceof DOMException && e.message.toLowerCase().includes("aborted") || e instanceof TypeError && e.message.toLowerCase().includes("cancelled") || e instanceof TypeError && e.message.toLowerCase().includes("annulé"))
      return {};
    throw e;
  }
};
export {
  p as trackingFn
};
